// @mui
import { Grid } from '@mui/material';
// components
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { AppConversionRates } from '../../../sections/@dashboard/app';

import moment from 'moment';

// ---------------------------------------------------------------------

export default function AmountTotal({
    department = null,
    selectedValue = 'one',
    startDay = moment().startOf('month').format('YYYYMMDD'),
    toDay = moment().format('YYYYMMDD'),
}) {
    const { t } = useTranslation();

    const userRef = useRef(null);
    const [dataDateStatistics, setDataDateStatistics] = useState([]);
    const [dataStatistics, setDataStatistics] = useState([]);
    const [getFlagsStatistics, setGetFlagsStatistics] = useState(false);
    const refFlagsStatistics = useRef(false);

    useEffect(() => {
        setTimeout(() => {
            getDataStatDepart();
        }, 600);
    }, [startDay, toDay, selectedValue, department]);

    //Biểu đồ về chi phí/số lượng của mỗi nhân viên trong 1 phòng ban
    const getDataStatDepart = useCallback(() => {
        if (refFlagsStatistics.current || !department?.id) {
            return;
        }
        setGetFlagsStatistics(true);
        refFlagsStatistics.current = true;
        const InVal = [startDay, toDay, department?.id];
        sendRequest(
            serviceList.getStatisticsListEtk,
            InVal,
            getDataResultStatDepart,
            true,
            timeOutFunctStatDepart,
            40000
        );
    }, [startDay, toDay, department, selectedValue]);

    const getDataResultStatDepart = (reqInfoMap, message) => {
        setGetFlagsStatistics(false);
        refFlagsStatistics.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataDateStatistics(message.proc_data.rows[0].o_1);
            setDataStatistics(message.proc_data.rows[0].o_2);
        }
    };

    const timeOutFunctStatDepart = (reqInfo) => {
        setGetFlagsStatistics(false);
        refFlagsStatistics.current = false;
    };

    const renderHeaederSubDepartment = () => {
        try {
            const startDate = glb_sv.convertMultipleDate(dataDateStatistics.start_date);
            const endDate = glb_sv.convertMultipleDate(dataDateStatistics.end_date);
            return (
                <>
                    {t('at_department')} <b>{department ? department.departs_nm : dataStatistics[0].departs_nm}:</b>{' '}
                    <span>
                        <b>{startDate}</b> {t('to').toLowerCase()} <b>{endDate}</b>
                    </span>
                    <br />
                    {dataStatistics.length > 0 ? '' : t('not_data_report')}
                </>
            );
        } catch (error) {}
    };

    return (
        <>
            <Grid item xs={12} md={12} lg={6}>
                <AppConversionRates
                    subheader={renderHeaederSubDepartment()}
                    title={t('depart_money')}
                    label="user_nm"
                    value="tong_gia_user"
                    chartData={dataStatistics}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <AppConversionRates
                    subheader={renderHeaederSubDepartment()}
                    title={t('depart_qty')}
                    label="user_nm"
                    value="tong_sl_user"
                    chartData={dataStatistics}
                />
            </Grid>
        </>
    );
}
